module.exports = __webpack_public_path__ + "img/upload_file.59aeaed6.svg";